import { defineMessages } from 'react-intl'

import { PASSENGER_TYPE } from './constants'

export const passengerTypeMessages = defineMessages({
  [PASSENGER_TYPE.ADULT]: {
    id: 'dictionary.adult',
    defaultMessage: 'Adult'
  },
  [PASSENGER_TYPE.SENIOR]: {
    id: 'dictionary.senior',
    defaultMessage: 'Senior'
  },
  [PASSENGER_TYPE.CHILD]: {
    id: 'dictionary.child',
    defaultMessage: 'Child'
  },
  [PASSENGER_TYPE.PET]: {
    id: 'dictionary.pet',
    defaultMessage: 'Pet'
  }
})
